import React from 'react';
import { Box, Typography, Container, Grid } from '@mui/material';
import DynamicAdvertisement from './DynamicAdvertisement';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[900],
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Container maxWidth="lg">
        {/* Footer Advertisements */}
        <Box sx={{ mb: 2 }}>
          <Grid container spacing={2} justifyContent="center">
            <DynamicAdvertisement position="footer-right" />
            <DynamicAdvertisement position="footer-left" />
          </Grid>
        </Box>

        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            {'© '}
            {new Date().getFullYear()}
            {' Opinion. All rights reserved.'}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;